import request from '@/utils/request'
import axios from 'axios'

export function getCategories(data) {
  return request({
    url: '/dashboard/categories',
    method: 'post',
    data,
  })
}

export function getLocations() {
  return request({
    url: '/dashboard/locations',
    method: 'get',
  })
}

export function getRoles() {
  return request({
    url: '/dashboard/roles',
    method: 'get',
  })
}

export function getBrandRoles(data) {
  return request({
    url: '/dashboard/roles/v2',
    method: 'post',
    data,
  })
}

export function getLevels() {
  return request({
    url: '/dashboard/levels',
    method: 'get',
  })
}

export function getBrandRoleLevels(data) {
  return request({
    url: '/dashboard/levels/v2',
    method: 'post',
    data,
  })
}

export function getEmployees(data) {
  return request({
    url: '/dashboard/employees',
    method: 'post',
    data,
  })
}

export function getRegisters(data) {
  return request({
    url: '/dashboard/registers',
    method: 'post',
    data,
  })
}

export function getApplications(data) {
  return request({
    url: '/dashboard/applications',
    method: 'post',
    data,
  })
}

export function getStatus(data) {
  return request({
    url: '/dashboard/status',
    method: 'post',
    data,
  })
}

export function getSuccess(data) {
  return request({
    url: '/dashboard/success',
    method: 'post',
    data,
  })
}

export function getGuideMapping(data) {
  return request({
    url: '/dashboard/guide/mapping',
    method: 'post',
    data,
  })
}

export function getNotMatch(data, download = false, token, type) {
  let payload = {
    url: (download ? '/api' : '') + '/dashboard/notmatch' + (download ? `?&action=export&type=${type}` : ''),
    method: 'post',
    data,
  }

  if (download) {
    payload = {
      ...payload,
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    }
    return axios(payload)
  }

  return request(payload)
}

export function getApplicationsByLocationAndAgency(data, download = false, token) {
  let payload = {
    url: (download ? '/api' : '') + '/dashboard/applications/bylocationandagency' + (download ? '?&action=export' : ''),
    method: 'post',
    data,
  }
  if (download) {
    payload = {
      ...payload,
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    }
    return axios(payload)
  }

  return request(payload)
}

export function getPanelResult(data, download = false, token) {
  let payload = {
    url: (download ? '/api' : '') + '/dashboard/panelresult' + (download ? '?&action=export' : ''),
    method: 'post',
    data,
  }

  if (download) {
    payload = {
      ...payload,
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    }
    return axios(payload)
  }

  return request(payload)
}

export function getTimeOfSuccess(data, download = false, token) {
  let payload = {
    url: (download ? '/api' : '') + '/dashboard/timeofsuccess' + (download ? '?&action=export' : ''),
    method: 'post',
    data,
  }

  if (download) {
    payload = {
      ...payload,
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    }
    return axios(payload)
  }

  return request(payload)
}

export function getPanelResultByLocation(data, download = false, token) {
  let payload = {
    url: (download ? '/api' : '') + '/dashboard/panelresult/bylocation' + (download ? '?&action=export' : ''),
    method: 'post',
    data,
  }

  if (download) {
    payload = {
      ...payload,
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    }
    return axios(payload)
  }

  return request(payload)
}

export function getPanelResultByAgency(data, download = false, token) {
  let payload = {
    url: (download ? '/api' : '') + '/dashboard/panelresult/byagency' + (download ? '?&action=export' : ''),
    method: 'post',
    data,
  }

  if (download) {
    payload = {
      ...payload,
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    }
    return axios(payload)
  }

  return request(payload)
}
